import { styled } from '@mui/material/styles';
import { ListItemButton, ListItemText } from '@mui/material';
import logoWhite from '../../../pixels-ai-logo-white.svg';
import Box from '@mui/material/Box';

const Menu = styled('ul')`
  margin: 0;
  font-size: 14px;
  padding: 0;
`;

const MenuItem = styled('li')`
  list-style: none;
  margin-left: 40px;

  a {
    display: block;
    padding: 8px 6px;
    text-decoration: none;
    color: #fff;
    font-weight: 500;
    &:visited, &:active, &:hover {
      color: #eee;
    }
    ${props => props.theme.breakpoints.up('md')} {
      color: #fff;
      padding: 8px 12px;
      &:visited, &:active, &:hover {
        color: #eee;
      }
    }
  }
`;

const TopMenu = styled(Menu)`
  display: none;
  ${props => props.theme.breakpoints.up('md')} {
    display: flex;
  }
`

const Logo = styled('img')`
  width: 270px;
  height: 72px;
  display: block;
  max-width: 100%;
  object-fit: contain;
  ${props => props.theme.breakpoints.up('md')} {
    width: 480px;
    height: 72px;
  }
`;

const LogoAnchor = styled('a')`
  display: flex;
  align-items: center;
`;

const LogoHeader = styled('img')`
  height: 72px;
  display: block;
  max-width: 100%;
  object-fit: contain;
  ${props => props.theme.breakpoints.up('md')} {
    height: 72px;
  }
`;

const DrawerText = styled(ListItemText)`
  font-size: 18px;
`;

const DrawerRowAnchor = styled(Box)`
  position: relative;

  &.initial {
    &:before {
      content: ' ';
      position: absolute;
      width: calc(100% + 32px);
      height: 1px;
      left: -16px;
      top: 0;
      opacity: 0.1;
      background-color: #fff;
    }
  }
  &:after {
    content: ' ';
    position: absolute;
    width: calc(100% + 32px);
    height: 1px;
    left: -16px;
    bottom: 0;
    opacity: 0.1;
    background-color: #fff;
  }
`;

const ListMobileAnchor = ({ children, ...rest }) => (<ListItemButton component={'a'} {...rest}>{children}</ListItemButton>);

const LogoDrawer = styled('span')`
  width: 146px;
  height: 39px;
  background-image: url(${logoWhite});
  display: inline-block;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  text-indent: -9999px;
`;

export {
  Logo, LogoHeader, LogoAnchor, Menu, MenuItem, TopMenu,
  DrawerText, DrawerRowAnchor, LogoDrawer, ListMobileAnchor
};